module.exports = __webpack_public_path__ + "img/0.f6f2415f.jpg";